export * from './delete-kunde.service';
export * from './delete-kunde.service.module';